import { Component } from 'preact';
import PropTypes from 'prop-types';
import CustomCheck from '../CustomCheck';

import { setFinancingOptions } from '../../stores/FinancingSimulator';

export default class FinancingOption extends Component {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    const { checkedInInitialization } = this.props;

    if (checkedInInitialization) {
      this.handleInputChange();
    }
  }

  handleInputChange() {
    const { id, commissionCode, installments, installmentValue, onSelect } =
      this.props;

    const financingOption = {
      installmentsId: id,
      commissionCode,
      installments,
      installmentValue: this.maskedValue(installmentValue),
    };

    onSelect(financingOption);
    setFinancingOptions(financingOption);
  }

  maskedValue(number) {
    return number.toLocaleString('pt-br', { minimumFractionDigits: 2 });
  }

  render() {
    const { isChecked, installments, installmentValue, onOpenDetails, isOpen } =
      this.props;

    return (
      <div className={`financing-option ${isOpen && 'is-open'}`}>
        <div className="financing-option__content-wrapper">
          <div className="financing-option__installments">
            <CustomCheck
              checkStyle="dark"
              name="financing-option"
              type="radio"
              isChecked={isChecked}
              onChangeCheckable={this.handleInputChange}
            />

            <div className="financing-option__content">
              <div className="financing-option__content-conditions">
                <h6>Condição</h6>
                <h6>
                  <strong>
                    {installments}x de R$ {this.maskedValue(installmentValue)}
                  </strong>
                </h6>
              </div>
            </div>
          </div>

          <button
            type="button"
            className="financing-option__content-details-button"
            onClick={onOpenDetails}
          >
            {isOpen ? 'Fechar' : 'Ver'} detalhes
            <i className="icon icon-chevron-down" />
          </button>

          <hr className="financing-option__content-details-separator" />

          <div
            className={`financing-option__content-details ${
              this.state.open && 'show-details'
            }`}
          >
            <strong>Valor total financiado</strong>
            <div>R$ {this.maskedValue(installments * installmentValue)}</div>
          </div>
        </div>
      </div>
    );
  }
}

FinancingOption.defaultProps = {
  id: '',
  commissionCode: '',
  installments: '',
  installmentValue: '',
  isChecked: false,
  checkedInInitialization: false,
  isOpen: false,
};

FinancingOption.propTypes = {
  id: PropTypes.number,
  commissionCode: PropTypes.string,
  installments: PropTypes.number,
  installmentValue: PropTypes.number,
  isChecked: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  checkedInInitialization: PropTypes.bool,
  onOpenDetails: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};
